
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import React, { Component } from "react"
import {
  Container,
  Button,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import CouponsTable from "../BlockedCoupon/coupons";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "../../components/Common/withRouter"
import BlockedCouponViewForm from "./BlockedCouponViewForm";

// Utilities
import {
  createNotificationHelpers,
  loadBlockedCoupons,
  addBlockedCoupon,
  deleteBlockedCoupon,
  updateCouponEligibility,
  BLOCKED_COUPON_TABLE_COLUMNS,
} from "../utils";

class BlockedCouponView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      store_domain: "",
      loading: false,
      updatingEligibility: false,
      store_details: {},
      store_status: "",
      coupon: '',
      Coupons: 0,
      totalCoupons: 0,
      updated_at: null
    }

    // Initialize notification helpers
    const notifications = createNotificationHelpers();
    this.notify_info = notifications.notify_info;
    this.notify_error = notifications.notify_error;
    this.notify_success = notifications.notify_success;
  }

  /**
   * Deletes a blocked coupon
   */
  delete_coupon = async (coupon) => {
    const answer = window.confirm("Are you sure you want to delete this coupon?");
    if (!answer) {
      return;
    }

    const success = await deleteBlockedCoupon(
      this.state.store_domain,
      coupon,
      this.notify_success,
      this.notify_error
    );

    if (success) {
      await this.blocked_coupons();
    }
  }

  /**
   * Loads blocked coupons from API
   */
  blocked_coupons = async () => {
    const { store_domain } = this.state;
    if (!store_domain) return;

    this.setState({ loading: true });
    const records = await loadBlockedCoupons(store_domain, this.notify_error);

    if (!records) {
      this.setState({ loading: false });
      return;
    }

    const customer_list = records?.coupon_details?.reverse().map((ele) => ({
      ...ele,
      source: ele?.label ? ele?.label : "Auto BCL",
      applicable_to: ele?.applicable_to ? ele?.applicable_to : "",
      is_customer_segment: ele?.is_customer_segment ? "True" : "False",
      action: (
        <span>
          <Button
            color="danger"
            onClick={() => this.delete_coupon(ele.name)}
            className="btn btn-danger waves-effect waves-light"
            data-toggle="modal"
            data-target="#myModal"
          >
            Delete
          </Button>
        </span>
      )
    })).sort((a, b) => {
      // Sort by is_customer_segment: "True" first, then "False"
      if (a.is_customer_segment === "True" && b.is_customer_segment === "False") return -1;
      if (a.is_customer_segment === "False" && b.is_customer_segment === "True") return 1;
      return 0;
    }).map((ele, index) => ({
      ...ele,
      id: index + 1
    }));

    const data = {
      columns: BLOCKED_COUPON_TABLE_COLUMNS,
      rows: customer_list,
    };

    this.setState({
      totalCoupons: records?.coupons.length,
      Coupons: data,
      updated_at: records.updated_at ? new Date(records?.updated_at).toLocaleString("en-US") : null,
      loading: false
    });
  }
  componentDidMount() {
    const locationState = this.props.location?.state;
    const data = locationState?.data;
    if (data && data.store_domain) {
      const { store_domain, store_details, store_status } = data;
      this.setState({
        store_domain,
        store_details: { ...store_details },
        store_status
      }, this.blocked_coupons);
      return;
    }
    // Fallback: try query string ?store=
    const search = this.props.location?.search || '';
    const params = new URLSearchParams(search);
    const storeFromQuery = params.get('store');
    if (storeFromQuery) {
      this.setState({ store_domain: storeFromQuery }, this.blocked_coupons);
      return;
    }
    // If no context available, redirect
    window.location.href = '/stores';
  }
  /**
   * Handles form submission to add blocked coupon
   */
  handleValidSubmit = async (e) => {
    e.preventDefault();
    const { store_domain, coupon } = this.state;

    const result = await addBlockedCoupon(store_domain, coupon, this.notify_error);

    if (result) {
      if (result.error) {
        this.notify_error(result.error);
        return;
      }
      this.setState({ coupon: '' });
      await this.blocked_coupons();
      this.notify_success("Blocked coupon has been added successfully");
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  /**
   * Updates coupon eligibility for the store
   */
  handleCouponEligibility = async () => {
    this.setState({ updatingEligibility: true });

    const success = await updateCouponEligibility(
      this.state.store_domain,
      this.notify_error
    );

    this.setState({ updatingEligibility: false });

    if (success) {
      this.notify_success("Coupon eligibility updated successfully");
      await this.blocked_coupons();
    }
  }


  render() {
    const { loading, updatingEligibility, store_details, store_status, Coupons, coupon, updated_at, store_domain } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>
            <title>Veeper | AP -Blocked Coupon </title>
          </Helmet>
          <Container fluid>
            <Breadcrumbs
              title={("Blocked Coupon List")}
              breadcrumbItem={("Information")}
            />
            <ToastContainer />
            <Col md={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4"></CardTitle>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button className="btn btn-primary" onClick={this.handleCouponEligibility} disabled={updatingEligibility}>
                      {updatingEligibility ? (
                        <>
                          <Spinner size="sm" className="mr-2" /> Updating...
                        </>
                      ) : (
                        'Update Coupon Eligibility'
                      )}
                    </Button>
                    <Link to={{ pathname: "/merchant-details", search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined, state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain }, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <Button className="btn btn-dark">
                        <i className="fa fa-arrow-left"></i> Store Details
                      </Button>
                    </Link>
                  </div>
                  <hr />
                  <BlockedCouponViewForm
                    coupon={coupon}
                    updated_at={updated_at}
                    onInputChange={this.handleInputChange}
                    onSubmit={this.handleValidSubmit}
                  />
                </CardBody>
              </Card>
            </Col>

            <Col md={12}>
              {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px' }}>
                  <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                  <span style={{ marginLeft: '10px' }}>Loading...</span>
                </div>
              ) : (
                <CouponsTable data={Coupons} />
              )}
            </Col>
          </Container>
        </div>
      </React.Fragment >
    )
  }
}

BlockedCouponView.propTypes = {
  t: PropTypes.any
}
export default withRouter(BlockedCouponView)
